var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAaDiscountsAward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#D1FADF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#ECFDF3",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9667 30.7219L23 38L27.5884 35.247C27.7381 35.1572 27.8129 35.1123 27.8928 35.0947C27.9634 35.0792 28.0366 35.0792 28.1072 35.0947C28.1871 35.1123 28.2619 35.1572 28.4116 35.247L33 38L32.0343 30.7212M35 25C35 28.866 31.866 32 28 32C24.134 32 21 28.866 21 25C21 21.134 24.134 18 28 18C31.866 18 35 21.134 35 25Z",
    stroke: "#3E4784",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAaDiscountsAward);
export default __webpack_public_path__ + "static/media/aa-discounts-award.df04927bca146ee6a19bbd7f1514e25a.svg";
export { ForwardRef as ReactComponent };